@if (isErrorGetTeams) {
  <div
    id="ExchangeItems"
    class="page-layout blank"
    class="page-layout simple"
    fxLayout="column">
    <!-- HEADER -->
    <div class="header">
      <div
        class="name field"
        [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
        {{ 'TEAM-MANAGEMENT.TITLE' | translate }}
      </div>
    </div>
    <!-- / HEADER -->
    <div class="content-card" fxFill>
      <div class="message-box error user-created">
        <app-error-message [error]="errorGetTeams.error" />
      </div>
    </div>
  </div>
} @else {
  <div
    id="ExchangeItems"
    class="page-layout blank"
    class="page-layout simple"
    fxLayout="column">
    <!-- HEADER -->
    <div class="header">
      <div
        class="name field"
        [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
        {{ 'TEAM-MANAGEMENT.TITLE' | translate }}
      </div>
    </div>
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      fxLayout="column"
      fxFlex
      fxFill>
      <mat-tab label="{{'TEAMS-PAGE.STANDARD' | translate}}">
        <app-exchange-page
          exchangeType="team"
          url="/teams"
          [isClassTeams]="false"
          [displayedColumns]="displayedColumns"
          [hiddenColumns]="hiddenColumns"
          [dataSource]="standardTeamsDataSource"
          [addDialogComponent]="TeamsStandardAddDialogComponent"
          [isLoading]="isLoading"
          [hasNoExchangeItems]="hasNoStandardTeam"
          (refreshList)="updateStandardTeams()" >
          <mat-form-field appearance="fill" class="simplified schoolyear-selector-field">
            <mat-label>{{'TEAMS-PAGE.SEARCH-NAME-FIELD' | translate}}</mat-label>
            <input
              matInput
              type="text"
              [formControl]="nameStandardFilter"/>
          </mat-form-field>
          <mat-form-field appearance="fill" class="simplified schoolyear-selector-field">
            <mat-label>{{'TEAMS-PAGE.SEARCH-EMAIL-FIELD' | translate}}</mat-label>
            <input
              matInput
              type="text"
              [formControl]="emailStandardFilter"/>
          </mat-form-field>
        </app-exchange-page>
      </mat-tab>
      <mat-tab label="{{'TEAMS-PAGE.CLASS' | translate}}">
        <app-exchange-page
          exchangeType="team"
          url="/teams"
          [isClassTeams]="true"
          [displayedColumns]="displayedClassColumns"
          [hiddenColumns]="hiddenClassColumns"
          [dataSource]="classTeamsDataSource"
          [addDialogComponent]="TeamsClassAddDialogComponent"
          [isLoading]="isLoading"
          [hasNoExchangeItems]="hasNoClassTeam"
          (refreshList)="updateClassTeams()" >
          <mat-form-field appearance="fill" class="simplified schoolyear-selector-field">
            <mat-label>{{'TEAMS-PAGE.SEARCH-NAME-FIELD' | translate}}</mat-label>
            <input
              matInput
              type="text"
              [formControl]="nameClassFilter"/>
          </mat-form-field>
          <mat-form-field appearance="fill" class="simplified schoolyear-selector-field">
            <mat-label>{{'TEAMS-PAGE.SEARCH-EMAIL-FIELD' | translate}}</mat-label>
            <input
              matInput
              type="text"
              [formControl]="emailClassFilter"/>
          </mat-form-field>
          <mat-form-field appearance="fill" class="simplified schoolyear-selector-field">
            <mat-label>Année scolaire</mat-label>
            <mat-select class="select-schoolyears" [(value)]="selectedSchoolYear" (selectionChange)="onSchoolYearChange($event.value)">
              <mat-option *ngFor="let year of schoolYears" [value]="year" >
                {{ year }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </app-exchange-page>
      </mat-tab>
    </mat-tab-group>
  </div>
}
